import { render, staticRenderFns } from "./supplies-online.vue?vue&type=template&id=08f295e4&scoped=true&"
import script from "./supplies-online.vue?vue&type=script&lang=js&"
export * from "./supplies-online.vue?vue&type=script&lang=js&"
import style0 from "./supplies-online.vue?vue&type=style&index=0&id=08f295e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f295e4",
  null
  
)

export default component.exports